module.exports = __webpack_public_path__ + "img/curve-web.13ceaf2f.png";